<template>
    <!-- ProductInventorySearchItem.vue -->
    <base-search-item :to="productUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {PRODUCT_INVENTORY_ICON} from '@/store/static/base-icons'
    import {INVENTORY_PRODUCT} from '@/router/product-inventory/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'ProductInventorySearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The list item icon
             */
            icon: {
                type: String,
                default: PRODUCT_INVENTORY_ICON
            }
        },
        computed: {
            productUrl () {
                const vm = this
                return {
                    name: INVENTORY_PRODUCT,
                    params: {
                        productId: vm.item.id
                    }
                }
            }
        }
    }
</script>
